import { FETCH_CART } from '../actions/types';

const cartReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_CART:
      return { ...action.payload };
    default:
      return state;
  }
};

export default cartReducer;
